import { getFieldId, toArray } from 'antd/es/form/util'
import type { NamePath } from 'antd/es/form/interface'
import type { Rule } from 'antd/es/form'

/**
 * antd's own `getFieldId`, not a reimplementation: `scrollToField` and `scrollToFirstError` look
 * fields up by exactly this id, so anything that resembles it breaks error focus.
 */
export function boundFieldId(name: NamePath, formName?: string): string | undefined {
  return getFieldId(toArray(name), formName)
}

/** React's `useId` returns `:r1:`, which is not a legal CSS selector and breaks e2e lookups. */
export function safeFieldId(reactId: string): string {
  return `vt-field-${reactId.replace(/:/g, '')}`
}

/**
 * Matches antd's derivation: a `warningOnly` rule does not block submit, so it does not make the
 * field required. Function rules are opaque, so pass `requirement` explicitly for those.
 */
export function isRequiredByRules(rules?: Rule[]): boolean {
  if (!rules?.length) return false
  return rules.some((rule) => typeof rule === 'object' && rule.required === true && !rule.warningOnly)
}
